import { redirect } from '@hooks'
import { createFileRoute } from '@tanstack/react-router'

const Webhook = redirect('/integration/webhook')

export const Route = createFileRoute('/webhook/')({
  component: Webhook,
})
